import { UniqueIdentifier } from "@dnd-kit/core"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { createContext } from "react"
import { isWorkarea, SortableItem } from "./dndModel"

export type SortableItemContextData = {
  isActive?: boolean
  isParentActive?: boolean
} & Pick<ReturnType<typeof useSortable>, 'setActivatorNodeRef' | 'attributes' | 'listeners'>
export const SortableItemContext = createContext<Partial<SortableItemContextData>>({})

type SortableProps = React.PropsWithChildren<{
  id: UniqueIdentifier
  data: SortableItem
  style?: React.CSSProperties
  activeStyle?: React.CSSProperties
}>

const Sortable = ({ id, data, style, activeStyle, children }: SortableProps) => {
  const { setNodeRef, setActivatorNodeRef, attributes, listeners, transform, transition, active } = useSortable({ id, data })
  const sortableStyle: React.CSSProperties = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition,
    ...style,
    ...(active?.id === id ? activeStyle : {})
  }

  const isActive = active?.id === id
  const isParentActive = isWorkarea(data) && active?.id === data.workareaGroupId


  return <div style={sortableStyle} ref={setNodeRef}>
    <SortableItemContext.Provider value={{ setActivatorNodeRef, attributes, listeners, isActive, isParentActive }}>
      {children}
    </SortableItemContext.Provider>
  </div>
}

export default Sortable
